import { render, staticRenderFns } from "./field-prompt-item.vue?vue&type=template&id=35a58df7&scoped=true&"
import script from "./field-prompt-item.vue?vue&type=script&lang=js&"
export * from "./field-prompt-item.vue?vue&type=script&lang=js&"
import style0 from "./field-prompt-item.vue?vue&type=style&index=0&id=35a58df7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a58df7",
  null
  
)

export default component.exports